/* Cameradan — comparateur avant/après, barre d'achat collante, variantes. Aucune dépendance. */
(function () {
  if (window.__cdBooted) { return; }
  window.__cdBooted = true;

  /* ---------- Avant / après ---------- */
  function initBA(root) {
    var ba = root.querySelector('.cd-ba');
    var hnd = root.querySelector('.cd-hnd');
    var bef = root.querySelector('.cd-bef');
    var aft = root.querySelector('.cd-aft');
    var cap = root.querySelector('.cd-cap');
    if (!ba || !hnd || ba.dataset.cdReady === '1') return;
    ba.dataset.cdReady = '1';
    var drag = false;

    function set(p) {
      p = Math.max(2, Math.min(98, p));
      ba.style.setProperty('--sx', p + '%');
      hnd.style.left = p + '%';
      hnd.setAttribute('aria-valuenow', Math.round(p));
    }
    function fromEvent(e) {
      var r = ba.getBoundingClientRect();
      var cx = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
      set((cx - r.left) / r.width * 100);
    }
    ba.addEventListener('pointerdown', function (e) {
      drag = true;
      if (ba.setPointerCapture) { try { ba.setPointerCapture(e.pointerId); } catch (err) {} }
      fromEvent(e);
    });
    ba.addEventListener('pointermove', function (e) { if (drag) fromEvent(e); });
    window.addEventListener('pointerup', function () { drag = false; });
    window.addEventListener('pointercancel', function () { drag = false; });
    hnd.addEventListener('keydown', function (e) {
      var c = parseFloat(hnd.getAttribute('aria-valuenow')) || 52;
      if (e.key === 'ArrowLeft') { set(c - 3); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(c + 3); e.preventDefault(); }
      if (e.key === 'Home') { set(2); e.preventDefault(); }
      if (e.key === 'End') { set(98); e.preventDefault(); }
    });

    var btns = root.querySelectorAll('.cd-swb');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        if (bef && btn.dataset.before) { bef.src = btn.dataset.before; }
        if (aft && btn.dataset.after) { aft.src = btn.dataset.after; }
        if (bef && btn.dataset.altBefore) { bef.alt = btn.dataset.altBefore; }
        if (aft && btn.dataset.altAfter) { aft.alt = btn.dataset.altAfter; }
        if (cap && btn.dataset.caption) { cap.textContent = btn.dataset.caption; }
        Array.prototype.forEach.call(btns, function (o) {
          var on = (o === btn);
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        set(52);
      });
    });
    set(52);
  }

  /* ---------- Barre d'achat collante ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-cd-sticky]');
    var buy = document.querySelector('[data-cd-buy]');
    if (!bar || !buy || bar.dataset.cdReady === '1') return;
    bar.dataset.cdReady = '1';
    function upd() {
      // visible dès que le bloc d'achat principal est entièrement passé au-dessus
      bar.hidden = buy.getBoundingClientRect().bottom > 0;
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
  }

  /* ---------- Sélecteur de variante ---------- */
  function initVariant() {
    var sel = document.querySelector('[data-cd-variant]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var price = opt.getAttribute('data-price');
      if (!price) return;
      var now = document.querySelector('[data-cd-price-now]');
      var sticky = document.querySelector('[data-cd-sticky-price]');
      if (now) now.textContent = price;
      if (sticky) sticky.textContent = price;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', sel.value);
      window.history.replaceState({}, '', url.toString());
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cd-ba]'), initBA);
    initSticky();
    initVariant();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target.querySelector ? e.target.querySelector('[data-cd-ba]') : null;
    if (t) initBA(t);
    initSticky();
    initVariant();
  });
})();
